$(document).on('ready', function () {
    $.fn.toggleFixedButton = function () {
        var $self = $(this);
        var $button = $self.find('.js-fixed-button');
        var $flag = $('.js-fixed-flag');
        var height;
        var collapseElement = $('.js-card-with-popup');
        var flag = false;

        var init = function () {
            if($flag.length) {
                height = $flag.position().top;
            }
            $(window).on('scroll', function () {
                flag = false;
                collapseElement.each(function () {
                    if($(this).hasClass('open')) {
                        $button.removeClass('active');
                        flag = true;
                        return;
                    }
                })
                if ($(window).scrollTop() > height && flag === false) {
                    $button.addClass('active');
                } else {
                    $button.removeClass('active');
                }
            });
        };

        init();
    };

    $('.js-fixed-button-wrapper').each(function () {
        $(this).data('toggleFixedButton', $(this).toggleFixedButton());
    });
});
